function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "5s4f7kmura",
  d: "M7 0C5.717 0 4.667 1.05 4.667 2.333H2.333C1.05 2.333 0 3.383 0 4.667h16.333c0-1.284-1.05-2.334-2.333-2.334h-2.333C11.667 1.05 10.617 0 9.333 0H7zM2.333 7v11.223c0 .257.187.444.444.444H13.58c.257 0 .443-.187.443-.444V7H11.69v8.167c0 .653-.513 1.166-1.167 1.166-.653 0-1.166-.513-1.166-1.166V7H7.023v8.167c0 .653-.513 1.166-1.166 1.166-.654 0-1.167-.513-1.167-1.166V7H2.333z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1000 -1014) translate(1000 1014) translate(.333 .167)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "s9w6ddjxub",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5s4f7kmura"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#212B36",
  fillRule: "nonzero",
  xlinkHref: "#5s4f7kmura"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#CE3E3B",
  fillRule: "nonzero",
  mask: "url(#s9w6ddjxub)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  rx: 4,
  transform: "translate(-2.333 -1.167)"
}))))));

function SvgIconsPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPencil);
export default __webpack_public_path__ + "static/media/icons-pencil.b3caa5d2.svg";
export { ForwardRef as ReactComponent };